import { observer } from 'mobx-react'
import { useEffect, useState } from 'react'
import ContentState from '../../../../stores/ContentState'
import './index.scss'
import { ReactComponent as Search } from '../../../../assets/footer/search.svg'
import { ReactComponent as Reset } from '../../../../assets/career/refresh-ccw.svg'

import Select from '../Select'
import VacanciesList from '../VacanciesList'
import { observable, runInAction } from 'mobx'
import classNames from 'classnames'

export const VacanciesSearch = observable({
  search: {
    name: '',
    country: '',
    position: '',
    format: '',
  },
})

const Vacancies = observer(() => {
  const [search, setSearch] = useState({
    name: '',
    country: '',
    position: '',
    format: '',
  })

  const [isFocus, setFocus] = useState(false)

  const [width, setWidth] = useState(window.innerWidth)

  useEffect(() => {
    window.addEventListener('resize', () => setWidth(window.innerWidth))
  }, [])

  const reset = () => {
    ;(search.country.length ||
      search.position.length ||
      search.format.length ||
      search.name.length) &&
      setSearch({
        ...search,
        name: '',
        country: '',
        position: '',
        format: '',
      })
  }

  useEffect(() => {
    runInAction(() => {
      VacanciesSearch.search = search
    })
  }, [search])

  if (!ContentState.career.vacancies) return <></>

  const vacancies = ContentState.career.vacancies
  return (
    <section className="vacancies">
      <div
        className="vacancies__title"
        dangerouslySetInnerHTML={{ __html: vacancies.title }}
      ></div>

      <div className="vacancies__row">
        <div className={classNames('vacancies__search', isFocus && 'focused')}>
          <Search />
          <input
            className="input"
            value={search.name}
            placeholder={vacancies.searchPlaceholder}
            onChange={(e) =>
              setSearch({
                ...search,
                name: e.target.value,
              })
            }
            onFocus={() => setFocus(true)}
            onBlur={() => setFocus(false)}
          />
        </div>
        {width > 990 ? (
          <div className="vacancies__selects">
            <Select
              list={vacancies.countryList}
              defaultValue={vacancies.countryPlaceholder}
              value={search.country}
              setValue={(value) => setSearch({ ...search, country: value })}
            />
            <Select
              list={vacancies.positionList}
              defaultValue={vacancies.positionPlaceholder}
              value={search.position}
              setValue={(value) => setSearch({ ...search, position: value })}
            />
            <Select
              list={vacancies.formatList}
              defaultValue={vacancies.formatPlaceholder}
              value={search.format}
              setValue={(value) => setSearch({ ...search, format: value })}
            />
          </div>
        ) : (
          <>
            {' '}
            <Select
              list={vacancies.countryList}
              defaultValue={vacancies.countryPlaceholder}
              value={search.country}
              setValue={(value) => setSearch({ ...search, country: value })}
            />
            <Select
              list={vacancies.positionList}
              defaultValue={vacancies.positionPlaceholder}
              value={search.position}
              setValue={(value) => setSearch({ ...search, position: value })}
            />
            <Select
              list={vacancies.formatList}
              defaultValue={vacancies.formatPlaceholder}
              value={search.format}
              setValue={(value) => setSearch({ ...search, format: value })}
            />
          </>
        )}
        <div
          className={classNames(
            'vacancies__reset',
            !search.country.length &&
              !search.position.length &&
              !search.format.length &&
              !search.name.length &&
              'disabled-but',
          )}
          onClick={reset}
        >
          <span>
            <Reset /> {vacancies.clearText}
          </span>
        </div>
      </div>
      <VacanciesList vacancies={vacancies} />
    </section>
  )
})

export default Vacancies
